<!-- 由 suu 创建于 2022-06-23 Thursday -->
<template>
  <div class="ques-input">
    <div class="title">{{ curQues.field_title }}</div>
    <div class="content" v-if="inputType == 'text' || inputType == 'string'">
      <input
        class="input"
        type="text"
        v-model="value"
        @blur="bindblur"
        :maxlength="10"
      />
    </div>
    <template v-else>
      <div class="content">
        <input
          class="input"
          type="number"
          v-model="value"
          @focus="bindfocus"
          @blur="bindblur"
          :maxlength="10"
        />
        <span class="unit">{{ typeData[type].unit }}</span>
      </div>
      <div class="equal" v-if="result">{{ result }}</div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ques-input',

  components: {},

  props: {
    inputType: {
      type: String,
      default: 'digit'
    },
    type: {
      type: String,
      default: 'height'
    },
    curQues: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  data() {
    return {
      typeData: {
        height: {
          func: 'equalHeight',
          check: 'checkHeight',
          unit: 'CM'
        },
        weight: {
          func: 'equalWeight',
          check: 'checkWeight',
          unit: 'KG'
        },
        nutritional_goal_weight: {
          func: 'equalWeight',
          check: 'checkWeight',
          unit: 'KG'
        }
      },
      result: '', //最终显示在下面的文字
      value: ''
    }
  },

  computed: {},

  watch: {
    value(val) {
      this.inputType != 'string' && this[this.typeData[this.type].func](val)
    },
    curQues(nv) {
      this.value = nv.value
    }
  },

  created() {
    this.value = this.curQues.value
  },

  mounted() {},

  destroyed() {},

  methods: {
    equalHeight(value) {
      let height = parseFloat(value) || 0
      let mi = parseInt(height / 100) ? parseInt(height / 100) + '米' : ''
      let cm = height % 100 ? parseInt(height % 100) : 0
      cm = mi && cm < 10 ? '0' + cm : cm
      cm = mi ? String(cm).replace(/0+$/, '') : cm + '厘米'
      this.result = '= ' + mi + cm
    },
    equalWeight(value) {
      this.result = '= ' + (parseFloat(value) || 0) * 2 + '斤'
    },
    bindfocus() {
      console.log('输入聚焦')
      //因为在ipad中使用时收起键盘后点击任意位置都会触发输入框聚焦事件，导致用户输入后不能点击下一步，所以暂时注释聚焦时隐藏按钮的逻辑
      // this.$emit('change', { value: '' }, {})
    },
    bindblur(e) {
      console.log('输入离开', e, this.value)
      let value = this.value
      let checkResult =
        this.inputType != 'string' &&
        this[this.typeData[this.type].check](value)
      if (this.inputType != 'string' && !checkResult) {
        this.$emit('change', { value: '' }, {})
        return
      }
      this.value = this.inputType != 'string' ? parseFloat(value) : value
      //根据type类型决定将输入框的数字格式化成什么类型
      this.inputType != 'string' && this[this.typeData[this.type].func](value)
      this.$emit('change', { value: value }, {})
    },
    //检查身高是否合法
    checkHeight(value) {
      console.log('====================================')
      console.log('身高校验', value)
      console.log('====================================')
      let min = 100
      let max = 300
      let res = parseFloat(value)
      if (!res && res !== 0) {
        this.$toast('请输入数字')
        return false
      }
      if (res) {
        let y = String(res).indexOf('.') + 1 //获取小数点的位置
        let count = String(res).length - y //获取小数点后的个数
        if (y > 0 && count > 1) {
          this.$toast('小数点后只能有1位小数')
          return false
        }
      }
      if (res < min || res > max) {
        this.$toast('请输入' + min + ' - ' + max + '之间的数')
        return false
      }
      return true
    },
    //检查体重是否合法
    checkWeight(value) {
      let min = 30
      let max = 200
      let res = parseFloat(value)
      if (!res && res !== 0) {
        this.$toast('请输入数字')
        return false
      }
      if (res) {
        let y = String(res).indexOf('.') + 1 //获取小数点的位置
        let count = String(res).length - y //获取小数点后的个数
        if (y > 0 && count > 1) {
          this.$toast('小数点后只能有1位小数')
          return false
        }
      }
      if (res < min || res > max) {
        this.$toast('请输入' + min + ' - ' + max + '之间的数')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.ques-input {
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 22px;
    font-weight: 600;
    color: #202539;
    line-height: 32px;
  }
  .content {
    width: 184px;
    height: 44px;
    position: relative;
    margin-top: 70px;
  }
  .input {
    text-align: center;
    width: 184px;
    height: 44px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 22px;
    border: 3px solid #373d52;
    font-size: 24px;
    font-weight: 600;
    color: #373d52;
  }
  .unit {
    position: absolute;
    right: 6%;
    top: 50%;
    transform: translateY(-50%);
    font-size: 15px;
    font-weight: bold;
    color: #262f44;
    color: #000;
  }
  .equal {
    margin-top: vw(40);
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    color: #373d52;
  }
}
</style>
